import api from 'shared/api'

const FETCH_REQUEST = 'executiveRanking/FETCH_REQUEST'
const FETCH_SUCCESS = 'executiveRanking/FETCH_SUCCESS'
const FETCH_FAILURE = 'executiveRanking/FETCH_FAILURE'

const initialState = {
  result: {},
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadRanking(options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchRequest())

    return api(`api/v1/directors/executive_ranking`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: {
          ...state.result
        },
        errors: errors
      }
    default:
      return state
  }
}

